// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

import { csv, json } from 'd3-fetch';
import { max } from 'd3-array';
import { autoType } from 'd3-dsv';
import { index } from 'd3-array';
import { renderSvelteComponent } from './utils/render.js';

//components
import LineChart from './components/LineChart.svelte';
import BubbleMap from './components/BubbleMap.svelte';
import StackedBar from './components/StackedBar.svelte';

async function main() {
  const url = new URL('../_data/races/all.json', import.meta.url);
  // do what you need to do with "data"!
  const allData = await json(url);
  const data = allData.filter((d) => d.race == window.RACE)[0];

  if (window.CONTRIB_LINE) {
    // For line charts
    const timeseriesContrib = new URL(
      '../_data/contrib-timeseries.csv',
      import.meta.url
    );
    const timeDataContrib = await csv(timeseriesContrib, autoType);

    renderSvelteComponent(
      LineChart,
      /** @type {HTMLElement} */ (document.getElementById('linechart-raised')),
      {
        allData: timeDataContrib,
        race: window.RACE,
        candidates: [data.candidate1, data.candidate2],
        width: document.getElementById('linechart-raised').offsetWidth,
        chartType: 'raised',
        candidates_last: [data.candidate1_last, data.candidate2_last],
      }
    );
  }
  if (window.MAP) {
    // For maps
    const mapDataUrl = new URL('../_data/map-counties.csv', import.meta.url);
    const mapData = await csv(mapDataUrl, autoType);
    const mapDict = index(mapData, (d) => String(d.county).slice(1));
    /** @type {HTMLElement} */
    const mapTarget = document.getElementById('candidate-maps-container');
    const mapAttrs = [
      'Nathan Hochman',
      'Rob Bonta',
      'Lanhee Chen',
      'Malia M. Cohen',
      'Brian Dahle',
      'Gavin Newsom',
      'Ricardo Lara',
      'Robert Howell',
      'Eleni Kounalakis',
      'Angela Underwood Jacobs',
      'Shirley Weber',
      'Robert E. Bernosky',
      'Fiona Ma',
      'Jack Guerrero',
    ];
    const yMax = max(
      Array.from(mapDict.values()).map((row) =>
        max(mapAttrs.map((a) => +row[a]))
      )
    );

    const candidateOne = window.RACE == 'Controller' ? '#f27e7d' : '#5788b8';
    const candidateTwo = window.RACE == 'Controller' ? '#5788b8' : '#f27e7d';

    new BubbleMap({
      target: mapTarget,
      props: {
        title: data.candidate1,
        data: mapData,
        bubbleFill: candidateOne,
        showLegend: true,
        yMax,
        cityList: data.CANDIDATE1CITY,
      },
    });

    new BubbleMap({
      target: mapTarget,
      props: {
        title: data.candidate2,
        data: mapData,
        bubbleFill: candidateTwo,
        showLegend: false,
        yMax,
        cityList: data.CANDIDATE2CITY,
      },
    });
  }

  //////////////////EXPENSE LINE
  const timeseriesExpen = new URL(
    '../_data/expen-timeseries.csv',
    import.meta.url
  );
  const timeDataExpen = await csv(timeseriesExpen, autoType);

  renderSvelteComponent(
    LineChart,
    /** @type {HTMLElement} */ (document.getElementById('linechart-spent')),
    {
      allData: timeDataExpen,
      race: window.RACE,
      candidates: [data.candidate1, data.candidate2],
      width: document.getElementById('linechart-spent').offsetWidth,
      chartType: 'spending',
      candidates_last: [data.candidate1_last, data.candidate2_last],
    }
  );
}

main();
